
import { Column } from "primereact/column";
import MeaLink from "../../../../components/MeaLink";
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import MeaButton from "../../../../components/MeaButton";
import MeaDataTable from "../../../../components/MeaDataTable";
import { InputText } from "primereact/inputtext";
import CreateLevelModal from "./CreateLevelModal";
import levelsAPI from "../../../../services/levels";
import UpdateLevelModal from "./UpdateLevelModal";
import ImportLevelsClassesFromExcelModal from "../modals/ImportLevelsClassesFromExcelModal";
import { useNavigate, useParams } from "react-router-dom";
import { PERMISSION_TRAINING_LEVELS, PERMISSION_TRAINING_TASKS } from "../../../../permissions";
import { useAuthContext } from "../../../../hooks/useAuthContext";

const LevelsListComponent = forwardRef((props, ref) => {
  const { selectedFields, showAddButton, showFilterButton } = props;
  const { hasPermission } = useAuthContext();
  const navigate = useNavigate();
  const [page, setPage] = useState();
  const [pageSize, setPageSize] = useState();

  const params = useParams();
  const schoolId = params.schoolId
  const trainingId = params.trainingId;
  const accessToken = "";
  //
  const createModalRef = useRef();
  const updateModalRef = useRef();
  const importLevelsClassesFromExcelModalRef = useRef();
  //
  let selectedData = {
    name: selectedFields?.name ?? true,
    presentation: selectedFields?.presentation ?? true,
    totalCourses: selectedFields?.totalCourses ?? true,
    totalClasses: selectedFields?.totalClasses ?? true,
    edit: selectedFields?.edit ?? true,
  };
  //
  const [level, setLevel] = useState(null);
  //
  const queryList = levelsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    page,
    pageSize
  );
  //
  useImperativeHandle(ref, () => ({
    refresh: () => {
      queryList?.refetch();
    },
  }));
  //

  //
  const startToolbarTemplate = (
    <div>
      {showAddButton && (
        <>
          <MeaButton
            label="Créer un niveau"
            icon="pi pi-plus"
            size="small"
            className="p-button mr-2 action"
            onClick={() => {
              createModalRef.current.show(() => {
                queryList.refetch();
              });
            }}
            data-pr-tooltip="Nouveau niveau"
            permission={PERMISSION_TRAINING_LEVELS.CREATE}
          />
          <MeaButton disabled={true} icon="pi pi-cloud-upload" label="Importer" size="small" className="p-button mr-2" outlined
            onClick={() => {
              navigate("/school/" + schoolId + "/admin/trainings/" + trainingId + "/levels-import");
            }}
            data-pr-tooltip="Importer"
            permission={PERMISSION_TRAINING_TASKS.IMPORT_FROM_TRAINING}
          />
          <MeaButton disabled={true} icon="pi pi-cloud-upload" label="Importer depuis un fichier" size="small" className="p-button mr-2" outlined onClick={() => {
            if (importLevelsClassesFromExcelModalRef.current) {
              importLevelsClassesFromExcelModalRef.current.show(() => {
                //callback?.();
              });
            }
          }}
            permission={PERMISSION_TRAINING_TASKS.IMPORT_LEVELSCLASSES_FROM_EXCEL_FILE}
          />
        </>
      )}
    </div>
  );
  //
  return (
    <>
      <CreateLevelModal ref={createModalRef} schoolId={schoolId} trainingId={trainingId} accessToken={accessToken} />
      <MeaDataTable
        query={queryList}
        serviceAPI={levelsAPI}
        schoolId={schoolId}
        trainingId={trainingId}
        accessToken={accessToken}
        names={{ pagination: "level", singular: "niveau", plural: "niveaux" }}
        startToolbarTemplate={startToolbarTemplate}
        showDeleteButton={hasPermission(PERMISSION_TRAINING_LEVELS.DELETE)}
        showFilterButton={showFilterButton}
        setPage={setPage}
        setPageSize={setPageSize}
      >
        <Column
          selectionMode="multiple"
          headerStyle={{ width: "3rem" }}
        ></Column>
        {selectedData.name && (
          <Column
            field="name"
            header="Niveau"
            editor={(options) => (
              <InputText
                type="text"
                value={options.value}
                onChange={(e) => options.editorCallback(e.target.value)}
              />
            )}
            body={(item) => (
              <div className="flex align-items-center gap-2">
                {item.color && (
                  <div
                    style={{
                      width: "16px",
                      height: "16px",
                      borderRadius: "3px",
                      backgroundColor: item.color,
                      border: "1px solid #ccc",
                      flexShrink: 0,
                    }}
                  />
                )}
                <MeaLink
                  to={
                    "/school/" +
                    schoolId +
                    "/admin/trainings/" +
                    trainingId +
                    "/levels/" +
                    item.id
                  }
                  permission={PERMISSION_TRAINING_LEVELS.GET}
                >
                  {item.name}
                </MeaLink>
              </div>
            )}
          ></Column>
        )}
        {selectedData.presentation && (
          <Column
            field="presentation"
            header="Presentation"
            editor={(options) => (
              <InputText
                type="text"
                value={options.value}
                onChange={(e) => options.editorCallback(e.target.value)}
              />
            )}
          ></Column>
        )}
        {selectedData.totalClasses && (
          <Column field="total_classes" header="Nombre de classes"></Column>
        )}
        {selectedData.totalCourses && (
          <Column field="total_courses" header="Nombre de courses"></Column>
        )}
        {selectedData.edit && (
          <Column
            body={(item) => (
              <>
                <MeaButton
                  icon="pi pi-pencil"
                  rounded
                  text
                  style={{ padding: "0", height: "1.5rem" }}
                  aria-label="Filter"
                  onClick={() => {
                    setLevel(item);
                    if (updateModalRef.current) {
                      updateModalRef.current.show(() => {
                        queryList.refetch();
                      });
                    }
                  }}
                  permission={PERMISSION_TRAINING_LEVELS.UPDATE}
                />
              </>
            )}
            headerStyle={{ width: "10%", minWidth: "8rem" }}
            bodyStyle={{ textAlign: "center" }}
          ></Column>
        )}
      </MeaDataTable>
      <UpdateLevelModal ref={updateModalRef} level={level} schoolId={schoolId} trainingId={trainingId} accessToken={accessToken} />
      <ImportLevelsClassesFromExcelModal ref={importLevelsClassesFromExcelModalRef} />
    </>
  );
});

export default LevelsListComponent;
